var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSparkleGlyph = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SparkleGlyph_svg__a)",
  d: "M18.8 10.162c.326-.882 1.574-.882 1.9 0l1.04 2.81a8.1 8.1 0 0 0 4.788 4.788l2.81 1.04c.883.326.883 1.574 0 1.9l-2.81 1.04a8.1 8.1 0 0 0-4.788 4.788l-1.04 2.81c-.326.883-1.574.883-1.9 0l-1.04-2.81a8.1 8.1 0 0 0-4.788-4.788l-2.81-1.04c-.882-.326-.882-1.573 0-1.9l2.81-1.04a8.1 8.1 0 0 0 4.788-4.788z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#SparkleGlyph_svg__b)",
  d: "M6.806 2.53c.261-.706 1.26-.706 1.52 0l.509 1.374a4.05 4.05 0 0 0 2.394 2.394l1.374.508c.706.261.706 1.259 0 1.52l-1.374.509a4.05 4.05 0 0 0-2.394 2.394l-.509 1.374c-.26.706-1.259.706-1.52 0l-.508-1.374a4.05 4.05 0 0 0-2.394-2.394l-1.375-.509c-.705-.261-.705-1.259 0-1.52l1.375-.508a4.05 4.05 0 0 0 2.394-2.394z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "SparkleGlyph_svg__a",
  x1: 2,
  x2: 26,
  y1: 2,
  y2: 27.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F84CC8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EF8200"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SparkleGlyph_svg__b",
  x1: 2,
  x2: 26,
  y1: 2,
  y2: 27.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F84CC8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EF8200"
})))));
export default SvgSparkleGlyph;